import { Button } from '@shared/components/ui/button';
import { useTranslation } from 'react-i18next';

interface ErrorStateProps {
  error: Error;
  onRetry?: () => void;
  title?: string;
}

export const ErrorState = ({ error, onRetry, title }: ErrorStateProps) => {
  const { t } = useTranslation('withdrawalPaymentFilesModule');

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 p-8">
      <p className="text-base font-medium text-title">{title ?? t('errors.title')}</p>
      <p className="text-sm text-subtext">{error.message || t('errors.generic')}</p>
      {onRetry && (
        <Button variant="outline" onClick={onRetry} data-testid="retry-payment-files">
          {t('buttons.retry')}
        </Button>
      )}
    </div>
  );
};
